// components/PlaidLink.tsx
import React, { useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { exchangePublicToken } from "../../redux/bankSlice";
import { CircularProgress, Box } from "@mui/material";

interface PlaidLinkProps {
  token: string | null;
  onSuccess?: () => void;
}

const PlaidLink: React.FC<PlaidLinkProps> = ({ token, onSuccess }) => {
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.bank);

  const onSuccessCallback = async (publicToken: string) => {
    await dispatch(exchangePublicToken(publicToken));
    if (onSuccess) onSuccess();
  };

  const config = {
    token,
    onSuccess: onSuccessCallback,
    onExit: (err: any) => {
      console.log("Plaid link exit", err);
    },
  };

  const { open, ready } = usePlaidLink(config);

  useEffect(() => {
    if (ready && token) {
      open();
    }
  }, [ready, open, token]);

  return loading ? (
    <Box display="flex" justifyContent="center" p={4}>
      <CircularProgress />
    </Box>
  ) : null;
};

export default PlaidLink;
